// extracted by mini-css-extract-plugin
export var backdropBlur = "_mx-0";
export var contentCard = "_mx-5";
export var frame = "_mx-2";
export var image = "_mx-4";
export var imagePane = "_mx-3";
export var modal = "_mx-1";